import {getData, postData} from './redux_data';
import {
    GET_TIPO_MOV_REDEM,
    MODIFY_TIPO_MOV_REDEM,
    ADD_TIPO_MOV_REDEM,
    DELETE_TIPO_MOV_REDEM,
    UPDATE_TIPO_MOV_REDEM,
} from '../constants/action_types';

export function getTipoMovRedemList() {
    return getData('CvTipoMovRedems', GET_TIPO_MOV_REDEM);
}

export function modifyTipoMovRedem(TipoMovRedem) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_MOV_REDEM, payload: TipoMovRedem });
    }
}

export function addTipoMovRedem(TipoMovRedem) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_MOV_REDEM, payload: TipoMovRedem });
    }
}

export function removeTipoMovRedem(TipoMovRedem) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_MOV_REDEM, payload: TipoMovRedem });
    }
}

export function updateTipoMovRedemListDB (TipoMovRedemList) {
    return postData('CvTipoMovRedems/lista', UPDATE_TIPO_MOV_REDEM, TipoMovRedemList, 'Tipos de movimiento actualizados', undefined);

}

